var chunkMapping = {
	"1": [
		2
	],
	"2": [
		4
	],
	"3": [
		5
	],
	"4": [
		7
	],
	"5": [
		9
	],
	"6": [
		11
	],
	"7": [
		13
	],
	"8": [
		15
	],
	"9": [
		17
	],
	"10": [
		19
	],
	"11": [
		21
	],
	"12": [
		23
	],
	"13": [
		25
	],
	"14": [
		27
	],
	"15": [
		29
	],
	"16": [
		31
	],
	"17": [
		33
	],
	"18": [
		35
	]
};
var idToExternalAndNameMapping = {
	"2": [
		"default",
		"./Sidebar",
		3
	],
	"4": [
		"default",
		"./Header",
		3
	],
	"5": [
		"default",
		"./Dashboard",
		6
	],
	"7": [
		"default",
		"./Products",
		8
	],
	"9": [
		"default",
		"./Customers",
		10
	],
	"11": [
		"default",
		"./Booking",
		12
	],
	"13": [
		"default",
		"./BusinessUnit",
		14
	],
	"15": [
		"default",
		"./RevenueGroups",
		16
	],
	"17": [
		"default",
		"./CostElements",
		18
	],
	"19": [
		"default",
		"./PriceBook",
		20
	],
	"21": [
		"default",
		"./PriceTemplates",
		22
	],
	"23": [
		"default",
		"./ProductCategory",
		24
	],
	"25": [
		"default",
		"./Approval",
		26
	],
	"27": [
		"default",
		"./Shipping",
		28
	],
	"29": [
		"default",
		"./Login",
		30
	],
	"31": [
		"default",
		"./Roles",
		32
	],
	"33": [
		"default",
		"./UserRoles",
		34
	],
	"35": [
		"default",
		"./Reports",
		36
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}